import { inject, injectable } from "tsyringe";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { PaymentSummaryRepository } from "src/containers/payments/repositories/payment-summary/payment-summary";
import { autoBind } from "src/shared/decorators/autobind";
import { PgaPolicy } from "src/shared/models/pga-policy.model";
import { PaymentSummary } from "src/shared/models/payment-summary.model";

@injectable()
export class PaymentSummaryService {
    public readonly KEY_REDIRECT = "hashRedirect";

    constructor(
        @inject("PaymentSummaryRepository")
        private repository: PaymentSummaryRepository
    ) {}

    @autoBind
    getSummary(
        userIdentity: string,
        policy: PgaPolicy
    ): Observable<PaymentSummary> {
        return this.repository
            .getSummary(userIdentity, policy)
            .pipe(map((data) => PaymentSummary.fromJson<PaymentSummary>(data)));
    }

    @autoBind
    saveHashRedirect(hash: string) {
        sessionStorage.setItem(this.KEY_REDIRECT, hash);
    }

    @autoBind
    removeHashRedirect() {
        sessionStorage.removeItem(this.KEY_REDIRECT);
    }
}
